import { getTelemetryConfig, shouldUseAppInsightsTransport } from "../telemetryConfig";

let appInsightsClient = null;
let appInsightsModulePromise = null;

async function loadAppInsightsModule() {
  if (!appInsightsModulePromise) {
    appInsightsModulePromise = import("@microsoft/applicationinsights-web");
  }
  return appInsightsModulePromise;
}

export async function initAppInsightsTransport() {
  if (appInsightsClient || !shouldUseAppInsightsTransport()) {
    return appInsightsClient;
  }

  const { ApplicationInsights } = await loadAppInsightsModule();
  const { applicationInsightsConnectionString } = getTelemetryConfig();
  appInsightsClient = new ApplicationInsights({
    config: {
      connectionString: applicationInsightsConnectionString,
      enableAutoRouteTracking: true,
      disableAjaxTracking: false,
      disableFetchTracking: true,
      enableCorsCorrelation: true,
      enableRequestHeaderTracking: true,
      enableResponseHeaderTracking: true,
    },
  });
  appInsightsClient.loadAppInsights();
  appInsightsClient.trackPageView();
  return appInsightsClient;
}

export function sendAppInsightsTelemetryEvent(event) {
  void initAppInsightsTransport().then((client) => {
    if (!client || !event?.name) {
      return;
    }

    const properties = { ...event };
    delete properties.name;

    client.trackEvent({ name: event.name }, properties);
  });
}

export function trackAppInsightsError(error, properties = {}) {
  void initAppInsightsTransport().then((client) => {
    if (!client) {
      return;
    }

    if (error instanceof Error) {
      client.trackException({ exception: error, properties });
      return;
    }

    client.trackException({
      exception: new Error(String(error)),
      properties,
    });
  });
}

export function resetAppInsightsTransportForTests() {
  appInsightsClient = null;
}
